<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17gJ5So/tc-custom/9781558325715.jpg?1705924464478" alt="This image is the cover for the book Sober Kitchen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sober Kitchen
      </h1>
      <p class="bookDescription body article font2">
        <b>“The thoughtful advice accompanying almost every entry makes [these recipes] invaluable for recovering addicts in need of a nourishing diet.” —<i>Publishers Weekly</i></b><br/><br/><i>The Sober Kitchen</i> is the first major book to focus on the important and often overlooked link between food and recovery. Professional chef and recovering alcoholic Liz Scott serves up this groundbreaking cookbook chock full of vital information on basic nutrition and current addiction research, as well as more than 300 delicious, simple recipes. She also offers plenty of realistic, down-to-earth advice and encouragement, making <i>The Sober Kitchen</i> a complete culinary lifestyle companion.<br/><br/>“There is much a cook can do to help a recovering alcoholic . . . Chef Liz Scott shares what she learned.” —<i>The Detroit News</i><br/><br/>“Provides a wealth of basic information and dozens of outstanding recipes to benefit both people in recovery and those who take care of them. In straightforward prose, she explains the dangers of dining out and gives advice on how to avoid being confronted with alcohol-laden dishes. Her recipes show creativity, especially in shortcut desserts.” —<i>Booklist</i><br/><br/>“Chef Scott, herself a recovering alcoholic, has developed recipes and menus that help the addicted to navigate three stages of recovery . . . Filling a gap, this well-researched and easy-to-follow cookbook is recommended for public libraries and consumer health collections.” —<i>Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Liz Scott, Robert L. DuPont
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0e06d784